import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="bg-navy text-white py-20 px-4" data-id="element-80">
      <div className="max-w-4xl mx-auto text-center" data-id="element-81">
        <h2 className="text-3xl md:text-5xl font-heading font-bold mb-6 leading-tight" data-id="element-82">
          No tienes que pagarle $500 a un consultor ni esperar 5 años a "ver qué
          pasa".
        </h2>

        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto" data-id="element-83">
          Accede hoy mismo a la estrategia completa que te dará el poder de
          decidir dónde vivir y qué auto manejar.
        </p>

        <div id="precio" className="bg-white text-navy rounded-2xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto relative overflow-hidden" data-id="element-84">
          {/* Decorative badge */}
          <div className="absolute top-0 right-0 bg-gold text-navy-dark font-bold py-1 px-8 transform translate-x-8 translate-y-4 rotate-45 shadow-md" data-id="element-85">
            OFERTA
          </div>

          <h3 className="text-2xl font-bold mb-2" data-id="element-86">
            Sistema Completo "Método 700+"
          </h3>

          <div className="flex flex-col items-center my-8 gap-2" data-id="element-87">
            <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-88">
              $97 USD
            </span>
            <span className="text-4xl text-gray-400 line-through font-bold" data-id="element-89">
              $27 USD
            </span>
            <div className="bg-gold-light border-2 border-gold rounded-xl px-6 py-4 mt-2" data-id="element-90">
              <p className="text-sm font-semibold text-gold uppercase tracking-wider mb-1" data-id="element-91">
                Precio de descuento
              </p>
              <span className="text-6xl md:text-7xl font-bold text-navy leading-none" data-id="element-92">
                $6.39{' '}
                <span className="text-2xl text-text-muted font-normal" data-id="element-93">
                  USD
                </span>
              </span>
            </div>
          </div>

          <div className="mb-8" data-id="element-94">
            <CTAButton animate={true} href="https://realenlinea.com/cart/51230153605424:1" data-id="element-95" />
          </div>

          <div className="flex items-center justify-center text-sm text-text-muted mt-6 border-t border-gray-200 pt-6" data-id="element-96">
            <ShieldCheckIcon className="w-5 h-5 text-green-500 mr-2" data-id="element-97" />
            <span data-id="element-98">Garantía de satisfacción. Pago 100% seguro.</span>
          </div>
        </div>
      </div>
    </section>;
}